export const Direction = {
  vertical: 'vertical',
  horizontal: 'horizontal',
  compact: 'compact'
};
export default Direction;
//# sourceMappingURL=constants.js.map